var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreativeAiNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H17C18.1046 4 19 4.89543 19 6V13.5",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.28349C13.2917 9.37972 13.2917 9.62028 13.125 9.71651L9.375 11.8816C9.20833 11.9778 9 11.8575 9 11.6651L9 7.33493C9 7.14249 9.20833 7.0222 9.375 7.11843L13.125 9.28349Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14.5C9.75 14.0858 10.0858 13.75 10.5 13.75H20.5C20.9142 13.75 21.25 14.0858 21.25 14.5V20.5C21.25 20.9142 20.9142 21.25 20.5 21.25H10.5C10.0858 21.25 9.75 20.9142 9.75 20.5V14.5Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.4615L13.05 17.4073C13.4104 17.1646 13.8863 17.1824 14.2276 17.4513L18.9097 21.1409",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeAiNew);
export default __webpack_public_path__ + "static/media/CreativeAiNew.70c32e8f.svg";
export { ForwardRef as ReactComponent };